import { Component } from '@verndale/core';
import Dropdown from '../../components/dropdown';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      dropdown: this.el.querySelector('select.tab-mobile__dropdown'),

      tabs: [],
      tabList: this.el.querySelector('[role="tablist"]'),
      tabPanels: this.el.querySelectorAll('[role="tabpanel"]')
    };
    this.className = 'hide-card';
    this.maxCards = this.el.dataset.maxCards;
    this.maxMobile = this.el.dataset.maxMobile
      ? this.el.dataset.maxMobile
      : 1280;
    this.breakpoint = matchMedia(`(max-width: ${this.maxMobile}px)`);
    this.products = [...this.dom.tabPanels];
    // Enable arrow navigation between tabs in the tab list
    this.tabFocus = 0;

    if (this.dom.tabPanels.length > 0) {
      this.populateTabs();
    }

    if (this.dom.dropdown) {
      this.dom.dropdown.selectedIndex = 1;
      this.dropdown = new Dropdown(this.dom.dropdown);
      this.dropdownPlaceholder = this.dom.dropdown.querySelector(
        'option.emptyOption'
      );
      // Populate Mobile dropdown with the panes of desktop
      this.populateDropdown();
    }
  }

  addListeners() {
    if (this.dropdown) {
      this.dropdown.on('option', e => {
        this.showTabMobile(e.target.value);
      });
    } else {
      this.products.map(item => {
        item.removeAttribute('hidden');
      });
    }

    this.dom.tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        this.changeTabs(e);
      });
    });

    this.dom.tabList.addEventListener('keydown', e => {
      this.tabsKeyMove(e);
    });
  }

  populateTabs() {
    let options = '';
    options = [...this.dom.tabPanels]
      .map((item, idx) => {
        const title = item.dataset.title;

        const { tabImage: image, tabDesc: description } = item.dataset;
        const isFirstElement = idx === 0;
        const id = `panel-${idx}`;

        item.setAttribute('id', id);
        item.setAttribute('ariaLabelled', id);

        return `
        <button role="tab" class="image-content-tab__item
        ${isFirstElement && 'active'}"
        data-title="${title}" aria-selected="${isFirstElement ? true : false}"
         aria-controls="${id}" tabindex="${isFirstElement ? 0 : -1}">
            <img src="${image}" alt="${description}">
            <span>${title}</span>
        </button>`;
      })
      .join('');

    this.dom.tabList.innerHTML = options;
    this.dom.tabs = this.el.querySelectorAll('[role="tab"]');
    this.dom.tabPanels[this.tabFocus].removeAttribute('hidden');
  }

  populateDropdown() {
    let options = '';
    options = [...this.dom.tabs]
      .map((item, idx) => {
        return `<option value="panel-${idx}">${item.dataset.title}</option>`;
      })
      .join('');

    this.dom.dropdown.innerHTML = options;

    if (options) {
      if (options.length > 1 && this.dropdownPlaceholder) {
        this.dom.dropdown.insertBefore(
          this.dropdownPlaceholder,
          this.dom.dropdown[0]
        );
      }
    } else {
      this.dom.dropdownPlaceholder.innerHTML = `<option value="">${this.el.dataset.requestedOption}</option>`;
    }

    this.dropdown.update();
  }

  showTabMobile(name) {
    if (this.maxCards <= this.products.length && this.breakpoint.matches) {
      const selectedTab = this.products.filter(item => {
        item.setAttribute('hidden', true);
        return item.getAttribute('id') === name;
      });

      if (selectedTab && selectedTab.length > 0) {
        selectedTab[0].removeAttribute('hidden');
      }
    }
  }

  tabsKeyMove(e) {
    // Move right
    if (e.keyCode === 39 || e.keyCode === 37) {
      this.dom.tabs[this.tabFocus].setAttribute('tabindex', -1);
      if (e.keyCode === 39) {
        this.tabFocus++;
        // If we're at the end, go to the start
        if (this.tabFocus >= this.dom.tabs.length) {
          this.tabFocus = 0;
        }
        // Move left
      } else if (e.keyCode === 37) {
        this.tabFocus--;
        // If we're at the start, move to the end
        if (this.tabFocus < 0) {
          this.tabFocus = this.dom.tabs.length - 1;
        }
      }

      this.dom.tabs[this.tabFocus].setAttribute('tabindex', 0);
      this.dom.tabs[this.tabFocus].focus();
    }
  }

  changeTabs(e) {
    const target = e.target;

    if (target) {
      const parent = target.parentNode;

      this.dom.tabs.forEach(tab => {
        tab.classList.remove('active');
      });

      // Remove all current selected tabs
      parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach(t => t.setAttribute('aria-selected', false));

      // Set this tab as selected
      target.setAttribute('aria-selected', true);

      // Hide all tab panels
      this.el
        .querySelectorAll('[role="tabpanel"]')
        .forEach(p => p.setAttribute('hidden', true));

      // Show the selected panel
      this.el.parentNode
        .querySelector(`#${target.getAttribute('aria-controls')}`)
        .removeAttribute('hidden');

      // Add the active class on the clicked tab
      target.classList.add('active');
    }
  }
}

export default Module;
